export default async ({ app, redirect }): Promise<void> => {
  if (!app.$cookies.get('vsf-customer')) {
    redirect('/')
  }
}
